// =============================================
// NÓ: START (INÍCIO DO FLUXO) - MOBILE FIRST
// =============================================
// Arquivo: StartNode.tsx
// Descrição: Nó de início do fluxo - otimizado para touch
// =============================================

import React from 'react';
import { Handle, Position } from 'reactflow';
import ActionsBadge from './ActionsBadge';
import './NodeStyles.css';

interface StartNodeProps {
  data: {
    label?: string;
    actions?: {
      input?: any[];
      output?: any[];
    };
  };
  selected?: boolean;
}

const StartNode: React.FC<StartNodeProps> = ({ data, selected }) => {
  return (
    <div className={`custom-node start-node ${selected ? 'selected' : ''}`}>
      <div className="node-icon">
        <i className="fas fa-play-circle"></i>
      </div>
      <div className="node-content">
        <div className="node-label">{data.label || 'Início'}</div>
        <ActionsBadge actions={data.actions} />
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="start-output"
        className="node-handle source-handle"
      />
    </div>
  );
};

export default StartNode;
